import script from "./WaterTypeList.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaterTypeList.component.vue?vue&type=script&lang=ts&setup=true"

import "./WaterTypeList.component.vue?vue&type=style&index=0&id=a4b2cf28&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b2cf28"]])

export default __exports__